"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFn = void 0;
const tslib_1 = require("tslib");
const createUrl_1 = require("../createUrl");
const axios_1 = tslib_1.__importDefault(require("axios"));
const queryFn = (clientData, options, servicesEndpoint) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { method, params, data, url, signal } = clientData;
    const fullUrl = (0, createUrl_1.createUrl)(servicesEndpoint, { client: url.startsWith('/') ? url.slice(1) : url });
    const axiosConfig = Object.assign(Object.assign(Object.assign({ data,
        params,
        method, url: fullUrl }, (signal ? signal : {})), { withCredentials: true }), options);
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.queryFn = queryFn;
//# sourceMappingURL=queryFetch.utils.js.map